import { render, staticRenderFns } from "./message.vue?vue&type=template&id=2c32a046&scoped=true&lang=pug"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=2c32a046&prod&scoped=true&lang=scss"
import style1 from "./message.vue?vue&type=style&index=1&id=2c32a046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32a046",
  null
  
)

export default component.exports